import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DateService } from '@aiwyn/shared';

@Component({
  selector: 'app-payment-method-is-not-from-user',
  templateUrl: './payment-method-is-not-from-user.component.html',
  styleUrls: ['./payment-method-is-not-from-user.component.scss'],
  standalone: false,
})
export class PaymentMethodIsNotFromUserComponent {

  constructor(public dialogRef: MatDialogRef<PaymentMethodIsNotFromUserComponent>) { }

  /**
   * Close the modal.
   */
  onClose(): void {
    this.dialogRef.close();
  }

  /**
   * Get support email.
   */
  getEmail(): string {
    const subdomain =  window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;
    return 'mailto:support@aiwyn.ai?subject=Error%20encountered&body=%0D%0A-----------------------------------------%0D%0APlace message above this line %0D%0AClient: ' + subdomain + ' %0D%0ATime: ' + DateService.getIsoDateTime();
  }
}
